import { IState } from '../../store';

export function isCountrysidePromoEnabled(state: IState) {
  const { experiments, isCountrysidePromoEnabled } = state;
  const experiment = experiments.find(({ name }) => name === 'countryside_promotions');
  const isExperimentActive = !!(experiment && experiment.abGroup === 1);

  return isCountrysidePromoEnabled && isExperimentActive;
}
